import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiService } from 'app/core/http/api.service';
import { environment as env } from '@env/environment';

import { Router } from '@angular/router';
import { HeaderComponent } from 'app/layout/header/header.component';
import { AuthenticationService } from 'app/shared/services/authentication.service';
import { Location } from '@angular/common';
import { HttpClient  } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class 

LoginComponent implements OnInit {
  result: any;
  conference_id: string = env.selectedEvent;
  con_name: string = env.con_name;
  con_date: string = env.con_date;
  // @Output() authEvent = new EventEmitter<string>();

  // submited:boolean = false;
  ip = '';
  msg='';
  emailVal = '';
  passwordVal = '';
  previousUrl='';


  constructor(
    private http:HttpClient,
    private location: Location,
    private apiServerice: ApiService,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute
  ) {
    this.msg = this.activatedRoute.snapshot.paramMap.get('msg') || '';
    this.emailVal = this.activatedRoute.snapshot.queryParamMap.get('email') || '';
    this.passwordVal = this.activatedRoute.snapshot.queryParamMap.get('password')|| '';

  }

  name: string = '';

  ngOnInit(): void {
       this.auth.currentMessage.subscribe((name) => (this.name = name));
    this.getIPAddress();
  }
  getIPAddress()
  {
    this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
      this.ip = res.ip;
    });
  }

  authLoginYes(fname: string, lname: string) {
    this.auth.changeMessage(fname);
  }
  logoutAndLogin(form: any){
 
    form.value.LogOutFromOtherDevice = 'Yes';
    // console.log('form11111=', form.value);
    this.onSummit(form);
  }
  NoLogIn(){
    this.result = '';
  }
  onSummit(form: any) {
    if (form.valid) {
      //console.log('form2', form.value);
      // console.log('link', `conferences/${env.selectedEvent}/register`);
      this.apiServerice.doPost(`login`, form.value).subscribe((res) => {
        // console.log('Besm allah Alrahman');
        // console.log('doPost', res);

        this.result = res;
        if (this.result.status == 'success') {
          localStorage.setItem('photo', this.result.user.photo);
          localStorage.setItem('token', this.result.user.jwt_token);
          localStorage.setItem('fname', this.result.user.fname);
          localStorage.setItem('lname', this.result.user.lname);
          localStorage.setItem('title', this.result.user.title);
          localStorage.setItem('user_id', this.result.user.id);
          // this.authEvent.emit('login');
          //console.log(res)

          this.authLoginYes(this.result.user.fname, this.result.user.lname);
          // this.router.navigateByUrl('');
       this.router.navigateByUrl('/live/a');
          // this.location.back()

          // this.router.navigateByUrl('recorded-sessions');
        }
        // this.status = res.status;
        // this.message = res.message;
      });
      // formValue.reset();
    } else {
      // alert('Form not valid');
    }
  }
}
